import { ITEMS_PER_PAGE } from '../constants';

/**
 * Paginates an array of items
 */
export const paginateItems = <T>(items: T[], page: number): T[] => {
  const startIndex = (page - 1) * ITEMS_PER_PAGE;
  return items.slice(startIndex, startIndex + ITEMS_PER_PAGE);
};

/**
 * Calculates total pages
 */
export const getTotalPages = (totalItems: number): number => {
  return Math.ceil(totalItems / ITEMS_PER_PAGE);
};
